import { Injectable } from '@angular/core';
import { AlarisApiService, AlarisConfigService } from '@campaign-portal/components-library';
import { ExportService } from '@helpers/api/export.service';
import { MDTask, MDTaskResult } from '@helpers/types/models';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { ManualDippingResultsTableFieldsService } from './manual-dipping-results-table.fields.service';
import { InputType } from '@campaign-portal/namespace/common/entityField';
import { FilterType } from '@campaign-portal/namespace/common/rpc.params';

@Injectable({
	providedIn: 'root'
})
export class ManualDippingResultsTableService {
	readonly loading$ = new BehaviorSubject<boolean>(false);

	pageParams = {
		limit: 25,
		activePage: 0
	};

	filters: { key: string; value: any }[] = [];
	sortingDefault = {
		active: 'md_task_id',
		direction: 'asc'
	};
	sorting = structuredClone(this.sortingDefault);

	constructor(
		private readonly api: AlarisApiService,
		private readonly exportService: ExportService,
		private readonly config: AlarisConfigService,
		private readonly fields: ManualDippingResultsTableFieldsService
	) {}

	loadResult(id: number): Observable<{ data: MDTaskResult[]; length: number }> {
		const params = {
			offset: this.pageParams.activePage * this.pageParams.limit,
			limit: this.pageParams.limit,
			active: this.sorting.active,
			direction: this.sorting.direction,
			filter: [
				{
					key: 'md_task_id',
					value: id.toString()
				},
				{
					key: 'result',
					value: '0'
				},
				...this.filters
			]
		};
		return this.api.loader<{ data: MDTaskResult[]; length: number }>('MDResults.Read', params, this.loading$);
	}

	loadTask(id: number): Observable<MDTask> {
		const params = {
			offset: 0,
			limit: 1,
			active: 'md_task_id',
			direction: 'asc',
			filter: [
				{
					key: 'md_task_id',
					value: id.toString()
				}
			]
		};
		return this.api
			.loader<{ data: MDTask[]; length: number }>('MDTasks.Read', params, this.loading$)
			.pipe(map((res) => res.data[0]));
	}

	export(mdTaskId: number): Observable<void> {
		const params = {
			active: 'md_task_id',
			direction: 'asc',
			filter: [
				{
					key: 'md_task_id',
					value: mdTaskId.toString()
				}
			]
		};
		return this.exportService.export(
			this.config.api,
			'MDResults.Read',
			params,
			this.fields.headers,
			'manual_dipping_results'
		);
	}

	exportNumbers(mdTaskId: number): Observable<void> {
		const params = {
			active: 'md_task_id',
			direction: 'asc',
			filter: [
				{
					key: 'md_task_id',
					value: mdTaskId.toString()
				}
			]
		};
		return this.exportService.export(
			this.config.api,
			'MDTasks.Read',
			params,
			[{
				id: 2,
				name: 'manual_dipping.numbers',
				variable: 'numbers',
				filterType: FilterType.LIKE,
				required: false,
				type: InputType.TEXT
			}],
			'manual_dipping_numbers'
		);
	}
}
